<template>
  <v-dialog v-model="estado_dialog" width="500" persistent>
    <v-card>
      <v-card-title> Aseguradora QUALITAS COSTA RICA </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="cabinista"
                label="Cabinista"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="cabinista_dis"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="reporte"
                label="Reporte"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="reporte_dis"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="inciso"
                label="Inciso"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="inciso_dis"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="endoso"
                label="Endoso"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="endoso_dis"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="siniestro"
                label="Siniestro"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="siniestro_dis"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="cerrarDialog()">Cerrar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="validarId()" v-if="campos_completos"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: true,
      id_cierre_qualitas: 0,
      cabinista: "",
      endoso: "",
      inciso: "",
      reporte: "",
      siniestro: "",
      estatus_asistencia: "",
      rule: [(v) => !!v || "Campos obligatorios"],
      campos_completos: true,
      /////
      cabinista_dis: false,
      endoso_dis: false,
      inciso_dis: false,
      reporte_dis: false,
      siniestro_dis: false,
    };
  },
  props: ["estado_dialog", "id_cabina"],
  methods: {
    listarDatos(estatus_asistencia) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      this.estatus_asistencia = estatus_asistencia;

      axios
        .get("api/CierreQualitasCR/Listar/" + this.id_cabina, configuracion)
        .then((response) => {
          if (response.data.length > 0) {
            this.id_cierre_qualitascr = response.data[0].id_cierre_qualitascr;
            this.cabinista = response.data[0].cabinista;
            this.endoso = response.data[0].endoso;
            this.inciso = response.data[0].inciso;
            this.reporte = response.data[0].reporte;
            this.siniestro = response.data[0].siniestro;

            if (
              this.$store.state.usuario.idUsuario == 1 ||
              this.$store.state.usuario.idUsuario == 5 ||
              this.$store.state.usuario.idUsuario == 1007 ||
              this.$store.state.usuario.idUsuario == 1009 ||
              this.$store.state.usuario.idUsuario == 1011
            ) {
              return;
            }

            if (
              this.cabinista.length > 0 &&
              this.endoso.length > 0 &&
              this.inciso.length > 0 &&
              this.reporte.length > 0 &&
              this.siniestro.length > 0
            ) {
              this.campos_completos = false;
            }

            if (this.cabinista.length > 0) {
              this.cabinista_dis = true;
            }
            if (this.endoso.length > 0) {
              this.endoso_dis = true;
            }
            if (this.inciso.length > 0) {
              this.inciso_dis = true;
            }
            if (this.reporte.length > 0) {
              this.reporte_dis = true;
            }
            if (this.siniestro.length > 0) {
              this.siniestro_dis = true;
            }
          }
        });
    },
    validarId() {
      if (this.id_cierre_qualitascr == 0) {
        this.crearRegistro();
      } else if (this.id_cierre_qualitascr > 0) {
        this.actualizarRegistro();
      }
    },
    crearRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/CierreQualitasCR/Crear",
          {
            idCabina: this.id_cabina,
            cabinista: this.cabinista,
            endoso: this.endoso,
            inciso: this.inciso,
            reporte: this.reporte,
            siniestro: this.siniestro,
          },
          configuracion
        )
        .then(() => {
          this.cerrarDialog();
        });
    },
    actualizarRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (this.estatus_asistencia == "FINALIZADO") {
        if (this.$refs.form.validate()) {
          axios
            .put(
              "api/CierreQualitasCR/Actualizar",
              {
                id_cierre_qualitascr: this.id_cierre_qualitascr,
                idCabina: this.id_cabina,
                cabinista: this.cabinista,
                endoso: this.endoso,
                inciso: this.inciso,
                reporte: this.reporte,
                siniestro: this.siniestro,
              },
              configuracion
            )
            .then(() => {
              this.cerrarDialog();
            });
        }
      } else {
        axios
          .put(
            "api/CierreQualitasCR/Actualizar",
            {
              id_cierre_qualitascr: this.id_cierre_qualitascr,
              idCabina: this.id_cabina,
              cabinista: this.cabinista,
              endoso: this.endoso,
              inciso: this.inciso,
              reporte: this.reporte,
              siniestro: this.siniestro,
            },
            configuracion
          )
          .then(() => {
            this.cerrarDialog();
          });
      }
    },
    cerrarDialog() {
      this.$emit("update:estado_dialog", !this.estado_dialog);
      this.id_cierre_qualitascr = 0;
      this.cabinista = "";
      this.endoso = "";
      this.inciso = "";
      this.reporte = "";
      this.siniestro = "";
      this.$refs.form.resetValidation();
    },
  },
};
</script>